export default [
  {
    header: 'Игры',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Список игр',
    route: 'games',
    icon: 'CastIcon',
    tagVariant: 'light-warning',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Создать игру',
    route: 'random-game-create',
    icon: 'CastIcon',
    tagVariant: 'light-warning',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Импорт расписания',
    route: 'schedule-import',
    icon: 'CalendarIcon',
    tagVariant: 'light-warning',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Игровые недели',
    route: 'game-weeks',
    icon: 'CalendarIcon',
    tagVariant: 'light-warning',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Игры Planfix',
    route: 'planfix-games',
    icon: 'ListIcon',
    tagVariant: 'light-warning',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Планфикс Пакеты',
    route: 'planfix-packs',
    icon: 'PackageIcon',
    tagVariant: 'light-warning',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Напоминалки об играх',
    route: 'game-reminders',
    icon: 'BellIcon',
    tagVariant: 'light-warning',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Telegram-синхронизация',
    route: 'telegram-sync',
    icon: 'RefreshCwIcon',
    tagVariant: 'light-warning',
    resource: 'games',
    action: 'view',
  },
  {
    title: 'Построитель игр',
    route: 'game-builder-list',
    icon: 'ToolIcon',
    tagVariant: 'light-warning',
    resource: 'games',
    action: 'view',
  },
]
